import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { url: String, content: String, classes: String }

  initialize() {
    this._id = `tooltip_${Math.floor(Math.random() * Date.now())}`
  }

  connect() {
    this.element.addEventListener('mouseenter', () => this.show())
    this.element.addEventListener('mouseleave', () => this.hide())
  }

  show() {
    this.abortXhr = new AbortController()
    if (this.urlValue){
      fetch(this.urlValue, { signal: this.abortXhr.signal })
        .then(response => response.text())
        .then(html => this.create(html))
        .catch(e => { /* Abort */ })
    } else if (this.contentValue) {
      this.create(this.contentValue)
    }
  }

  hide() {
    this.abortXhr?.abort()
    setTimeout(() => {
      if (!document.querySelector(`#${this._id}:hover`))
        this.destroy()
    }, 50)
  }

  create(content){
    this.destroy()
    let main = document.querySelector('main')
    let tooltip = document.createElement('div')
    tooltip.id = this._id
    tooltip.innerHTML = content
    tooltip.classList.add(...`invisible ${this.classesValue}`.trim().split(' '))
    main.appendChild(tooltip)

    let bb = this.element.getBoundingClientRect()
    tooltip.style.left = `${bb.left - main.getBoundingClientRect().x - tooltip.offsetWidth - 5}px`
    if (bb.y > window.innerHeight / 2)
      tooltip.style.top = `${bb.bottom - tooltip.offsetHeight + main.scrollTop}px`
    else
      tooltip.style.top = `${bb.top + main.scrollTop}px`

    tooltip.addEventListener('mouseleave', () => this.hide())
    tooltip.classList.remove('invisible')
  }

  destroy() {
    document.getElementById(this._id)?.remove()
  }
}
